import React from 'react';

import { assetUrl } from '~/helpers';
import ErrorLayout, { ErrorLayoutProps } from './ErrorLayout';

export type Error404Props = Omit<
  ErrorLayoutProps,
  'httpCode' | 'title' | 'message'
>;

export default function Error404(props: Error404Props) {
  return (
    <ErrorLayout
      {...props}
      title={'Oops! Something went wrong…'}
      message='Sorry the page you are looking for does not exist.'
      httpCode={404}
    >
      <img
        className='error-image'
        src={assetUrl('assets/images/joro/404.png')}
        width={357}
        height={180}
      />
    </ErrorLayout>
  );
}
